import Schema from 'AppReact/schema';

export default {
  format: Schema('string', 'primitive', { defaultValue: '' }),
  frequency: Schema('string', 'primitive', { defaultValue: '' }),
  occurrenceValues: Schema('string', 'array', { defaultValue: [] }),
  hour: Schema('string', 'primitive', { defaultValue: '' }),
  minute: Schema('string', 'primitive', { defaultValue: '' }),
  ampm: Schema('string', 'primitive', { defaultValue: '' }),

  formatError: Schema('string', 'primitive', { defaultValue: '' }),
  frequencyError: Schema('string', 'primitive', { defaultValue: '' }),
  occurrenceError: Schema('string', 'primitive', { defaultValue: '' }),
  timeError: Schema('string', 'primitive', { defaultValue: '' }),
  hidePdf: Schema('boolean', 'primitive-nullable', { defaultValue: null }),
  id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
}